import { Chip } from '@common-components';
import { AutoAwesomeOutlined } from '@icons';
import { messages } from 'i18n';

export default function ComingSoonChip() {
  return (
    <Chip
      label={messages.submissionQueuePage.comingSoon}
      size="extraSmall"
      variant="outlined"
      color="purple.300"
      textColor="purple.300"
      iconColor="purple.300"
      startIcon={AutoAwesomeOutlined}
    />
  );
}
